import { MapErrorFallback, MapSkeleton } from '@/components/Map';
import {
  EventsColumnSkeleton,
  TogglableEventColumnSkeleton,
} from '@/components/events';
import { EventColumnErrorFallback } from '@/components/events/EventColumn/EventColumnErrorFallback';
import { GenericErrorBoundary } from '@/components/common/GenericErrorBoundary';
import { Suspense, lazy } from 'react';

// Lazy load Event column components
const EventColumn = lazy(() =>
  import('@/components/events').then((module) => ({
    default: module.EventColumn,
  })),
);
const TogglableEventColumn = lazy(() =>
  import('@/components/events').then((module) => ({
    default: module.TogglableEventColumn,
  })),
);

// Lazy load heavy Map component
const Map = lazy(() =>
  import('@/components/Map').then((module) => ({ default: module.Map })),
);

export const HomePage = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 h-full">
      {/* Left column - Events */}
      <div className="h-screen grid grid-cols-2 gap-2 pt-[var(--header-height)]">
        {/* In Progress/Closed Toggleable Column */}
        <GenericErrorBoundary
          fallback={<EventColumnErrorFallback title="In Progress / Closed" />}
        >
          <Suspense fallback={<TogglableEventColumnSkeleton />}>
            <TogglableEventColumn />
          </Suspense>
        </GenericErrorBoundary>

        {/* Unassigned Events */}
        <GenericErrorBoundary
          fallback={<EventColumnErrorFallback title="Unassigned" />}
        >
          <Suspense fallback={<EventsColumnSkeleton title="Unassigned" />}>
            <EventColumn
              title="Unassigned"
              eventType="open"
              emptyMessage="No unassigned events"
              limit={11}
            />
          </Suspense>
        </GenericErrorBoundary>
      </div>

      {/* Right column */}
      <div className="h-full">
        <GenericErrorBoundary
          fallback={<MapErrorFallback className="h-full" />}
        >
          <Suspense fallback={<MapSkeleton />}>
            <Map />
          </Suspense>
        </GenericErrorBoundary>
      </div>
    </div>
  );
};
